<script>
  import { onMount } from 'svelte';

  import { mapTransform } from '../stores';

  export let data = [];

  let isInitial = true;

  onMount(() => {
    window.setTimeout(() => {
      isInitial = false;
    }, 600);
  });
</script>

<style>
  .km-bubble {
    pointer-events: none;
    transition: r 400ms;
  }
</style>

<g transform={$mapTransform}>
  {#each data as { cx, cy, r, fill, stroke, opacity }}
    <circle
      class="km-bubble"
      {cx}
      {cy}
      r={isInitial ? 0 : r}
      {fill}
      {stroke}
      fill-opacity={opacity} />
  {/each}
</g>
